import styled from '@emotion/styled';
import { Variables } from '../base';

export const MessagingBadge = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 24px;
    min-width: 24px;
    font-size: 12px;
    font-weight: ${Variables.FontWeight.regular};
    color: ${Variables.ThemeLight.PrimaryInverted2};
    background-color: ${Variables.ThemeLight.PrimaryInverted9};
    border-radius: 9999px;
    line-height: 1;
`;
interface IPill {
    note?: boolean;
}
export const MessagingPill = styled.span<IPill>`
    display: inline-flex;
    align-items: center;
    min-height: 20px;
    padding: 2px 8px;
    font-size: 14px;
    font-weight: ${Variables.FontWeight.regular};
    color: ${Variables.ThemeLight.PrimaryInverted2};
    background-color: ${(props: IPill): string =>
        props.note ? Variables.ThemeLight.NeutralMedium2 : Variables.ThemeLight.PrimaryInverted9};
    border-radius: 9999px;
    line-height: 1;
`;
